export default __webpack_public_path__ + "static/media/failed.6f579994.png";